import(/* webpackMode: "eager" */ "/github/workspace/src/app/not-found.tsx");
